import { useMemo } from 'react';
import { useFetchCorporateActions } from '@/features/tokenized-equity/hooks/useFetchCorporateActions';
import { CorporateActionStatus } from '@/features/tokenized-equity/grpc/types';
import {
  type UpcomingEvent,
  convertToDisplayEvent,
} from '@/features/tokenized-equity/components/portfolio/UpcomingEventsCard';

/**
 * Custom hook for fetching and transforming upcoming corporate actions
 * into UpcomingEvent format for display in UI components.
 *
 * @returns Object containing events array, loading state, and error state
 */
export function useUpcomingEvents() {
  // Fetch announced corporate actions
  const { data, isLoading, error } = useFetchCorporateActions({
    statuses: [CorporateActionStatus.CORPORATE_ACTION_STATUS_ANNOUNCED],
    page_size: 50,
  });

  // Convert corporate actions to display events
  const events = useMemo(() => {
    if (!data?.corporate_actions) return [];
    return data.corporate_actions
      .map(convertToDisplayEvent)
      .filter((event): event is UpcomingEvent => event !== null);
  }, [data]);

  return { events, isLoading, error };
}
